export default function Python_HOME() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Python_HOME</h1>
      <p>Content for Python_HOME goes here.</p>
    </div>
  );
}